import React, { useEffect, useState, useRef } from "react";
import { getIn } from "formik";

const CustomAutoCompleteCustomerSR = ({
  formik,
  field,
  label,
  searchFunction,
  width = "100%",
  required = true,
  showId = true,
}) => {
  const [value, setValue] = useState("");
  const [options, setOptions] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const timeoutIdRef = useRef(null);

  const error = getIn(formik.touched, field) && getIn(formik.errors, field);

  const buildDisplayText = (data) => {
    const base = `${data?.name || ""} - ${data?.phone || ""} - ${
      data?.email || ""
    } - ${data?.rfc || ""}`;
    return showId ? `(${data?.id}) ${base}` : base;
  };

  useEffect(() => {
    const selected = formik.values[field];
    if (selected && selected.id) {
      setValue(selected);
      setText(buildDisplayText(selected));
    }
  }, [formik.values[field], showId]);

  const handleChange = (event) => {
    const inputValue = event.target.value;
    setText(inputValue);

    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }

    if (inputValue.trim() === "") {
      setOptions([]);
      setValue(null);
      formik.setFieldValue(field, null);
      setLoading(false);
      return;
    }

    setLoading(true);
    timeoutIdRef.current = setTimeout(async () => {
      try {
        const data = await searchFunction(inputValue);
        setOptions(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }, 500);
  };

  const handleSelect = (data) => {
    setValue(data);
    setText(buildDisplayText(data));
    setShowOptions(false);
    formik.setFieldValue(field, data);
  };

  const clearSelection = () => {
    setText("");
    setValue(null);
    setOptions([]);
    setShowOptions(false);
    formik.setFieldValue(field, null);
  };

  const handleFocus = async () => {
    setShowOptions(true);
    if (text.trim() === "" && options.length === 0) {
      setLoading(true);
      try {
        const data = await searchFunction("");
        setOptions(data);
      } catch (error) {
        console.error("Error al cargar opciones:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleBlur = () => {
    setTimeout(() => setShowOptions(false), 150);
  };

  return (
    <div style={{ width }}>
      <div className="form-group">
        <label
          className="form-label"
          style={{ color: error ? "red" : "inherit", display: "block" }}
        >
          {label}
          {required && (
            <span style={{ color: error ? "red" : "inherit" }}> *</span>
          )}
        </label>
        <div style={{ position: "relative" }}>
          {loading && (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                zIndex: 2,
              }}
            >
              <span
                className="spinner-border spinner-border-sm text-primary"
                role="status"
              />
            </div>
          )}

          {text && (
            <button
              type="button"
              onClick={clearSelection}
              style={{
                position: "absolute",
                right: "27px",
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                color: "#999",
                cursor: "pointer",
                zIndex: 2,
                padding: 0,
                lineHeight: 1,
              }}
            >
              <i className="fa fa-times" />
            </button>
          )}

          <input
            type="text"
            className={`form-control ${error ? "is-invalid" : ""}`}
            placeholder={`Buscar ${label}`}
            value={text}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            autoComplete="password"
            style={{
              paddingLeft: loading ? "2rem" : undefined,
              paddingRight: text ? "2rem" : undefined,
            }}
          />

          {options.length > 0 && showOptions && (
            <ul
              className="list-group mt-2"
              style={{
                position: "absolute",
                zIndex: 1000,
                backgroundColor: "white",
                width: "100%",
                maxHeight: "200px",
                overflowY: "auto",
                border: "1px solid #ccc",
              }}
            >
              {options.map((data, index) => (
                <li
                  key={index}
                  className="list-group-item list-group-item-action"
                  onMouseDown={() => handleSelect(data)}
                >
                  {buildDisplayText(data)}
                </li>
              ))}
            </ul>
          )}

          {options.length === 0 && showOptions && !loading && (
            <ul
              className="list-group"
              style={{
                position: "absolute",
                zIndex: 1000,
                backgroundColor: "white",
                width: "100%",
                maxHeight: "200px",
                overflowY: "auto",
                border: "1px solid #ccc",
                top: "100%",
                marginTop: "0.25rem",
              }}
            >
              <li className="list-group-item list-group-item-action">
                No hay resultados
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomAutoCompleteCustomerSR;
